import type { BatteryProposalDto } from "~/api/dto/battery-proposal.dto"

import { batteryLightReachApplicationBundle } from "./battery-lightreach-bundle"
import { LightReachApplication } from "../../../ProposalSetup/financing/lightreach/LightReachApplication"

export { LIGHTREACH_STALE_OFFER_MESSAGE } from "../../../ProposalSetup/financing/lightreach/LightReachApplication"

/**
 * The seller's LightReach credit application on a Battery-Only Proposal: the
 * shared LightReach application, prefilled from the Proposal homeowner and
 * site, over Battery's commands.
 */
export function LightReachBatteryApplication({
  proposal,
  onClose,
  onSubmitted,
}: {
  proposal: BatteryProposalDto
  /** Keep stable (`useCallback`): the dialog re-binds when it changes. */
  onClose: () => void
  onSubmitted: () => void
}): JSX.Element {
  return (
    <LightReachApplication
      bundle={batteryLightReachApplicationBundle}
      proposalId={proposal.id}
      applicant={{
        firstName: proposal.homeowner?.firstName ?? ``,
        lastName: proposal.homeowner?.lastName ?? ``,
        phoneNumber: proposal.homeowner?.phone ?? ``,
        email: proposal.homeowner?.email ?? ``,
        address1: proposal.address.street,
        city: proposal.address.city,
        state: proposal.address.state,
        zip: proposal.address.postal,
      }}
      onClose={onClose}
      onSubmitted={onSubmitted}
    />
  )
}
